export default "__VITE_ASSET__BpwxtetA__"